import React from "react";
import Slider from "./slieder";
import { motion } from "framer-motion";
import FooterwithoutLogin from "./footerwithoutLogin";
import SEO from "../SEO/seo";

function AFrame() {
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
  };

  const scaleFade = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 },
  };

  const imageZoom = {
    hidden: { scale: 1.05, opacity: 0 },
    visible: { scale: 1, opacity: 1 },
  };

  const slideLeftToRight = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
  };

  const slideRightT0Left = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
  };
  return (
    <>
      <SEO
        title="Vertical Hydroponic | Space-Saving Farming by Kryzen Biotech"
        description="Vertical Hydroponics is a compact, high-efficiency growing system that stacks plants in layers — ideal for urban farming and small spaces, delivering higher yields in less area."
        keywords="vertical hydroponic, urban hydroponics, space-saving farming, vertical farming India, stacked hydroponic system, kryzen hydroponics, small space farming, hydroponic tower farming, a-frame"
        canonical="https://alpha.kryzen.com/kryzen-a-frame"
        ogTitle="Vertical Hydroponic | Space-Saving Farming by Kryzen Biotech"
        ogDescription="Maximize limited space with Kryzen’s Vertical Hydroponic system — a stacked growing solution for urban agriculture, delivering more yield per square foot."
        ogImage="https://res.cloudinary.com/bsgfcooa/image/upload/v1752818003/a-frame_te6zzr.jpg"
        twitterTitle="Vertical Hydroponic | Space-Saving Farming by Kryzen Biotech"
        twitterDescription="Kryzen’s Vertical Hydroponic system enables high-yield farming in tight spaces — perfect for urban growers seeking sustainable, soil-free cultivation methods."
      />
      <div>
        <Slider
          heding={"kryzen vertical hydroponic"}
          paragraph={
            "Vertical Hydroponics is a highly efficient, space-saving method of growing plants hydroponically in vertically stacked layers."
          }
        ></Slider>
        <div className="container mainDiv py-5">
          <div className="text-center py-5 px-3">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-5 fw-bold text-uppercase text-success mb-2"
            >
              kryzen vertical hydroponic
            </motion.h1>

            <hr></hr>
            <motion.p
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="lead mx-auto p-5"
              style={{ lineHeight: "1.8", fontSize: "25px" }}
            >
              Vertical Hydroponics is a highly efficient, space-saving method of
              growing plants hydroponically in vertically stacked layers. This
              system is ideal for urban farming or environments with limited
              space, as it maximizes the growing area by utilizing vertical
              space, allowing for higher yields in a smaller footprint.
            </motion.p>
          </div>

          <div className="row g-5 align-items-stretch mt-2">
            {/* Left Column */}
            <div className="col-md-4">
              <div
                className="card border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752818003/a-frame_te6zzr.jpg"
                  alt="A-frame vertical nft"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "280px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary text-uppercase">
                    A-frame vertical nft
                  </h5>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div
                className="card border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752232405/223_cubi5n.jpg"
                  alt="HEAT TRAPPING CARBONATE"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "280px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary text-uppercase">
                    App based Tracking
                  </h5>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-md-4">
              <div
                className="card border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752232405/222_xbvkvi.jpg"
                  alt="EXHAUST HALL POLY CARBONATE"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "280px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary text-uppercase">
                    fertigation automation
                  </h5>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-5 align-items-stretch mt-7">
            {/* Left Column */}
            <div className="col-md-4">
              <motion.div
                className="card border-0 h-100"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={slideLeftToRight}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <motion.img
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={imageZoom}
                  transition={{ duration: 0.6 }}
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752147218/mainframe_totggg.jpg"
                  alt="What is a Polyhouse?"
                  className="card-img-top img-fluid"
                  style={{ width: "100%", height: "300px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Main Frame Material
                  </h5>
                  <motion.p
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                  >
                    Constructed from high-quality hot-dip galvanized steel, our
                    structure boasts a Zinc-coating of 275g/m2, ensuring a
                    robust service life of over 20 years. The steel components
                    are assembled on-site without needing secondary processing.
                    Galvanized connectors and fasteners are designed to resist
                    rust for two decades, guaranteeing long-term durability and
                    reliability.
                  </motion.p>
                </div>
              </motion.div>
            </div>

            <div className="col-md-4">
              <motion.div
                className="card border-0 h-100"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={scaleFade}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <motion.img
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={imageZoom}
                  transition={{ duration: 0.6 }}
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752147339/out_ddbqic.webp"
                  alt="Grrenhouse Benefits"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "300px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Covering Materials
                  </h5>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  >
                    Our covering materials made up of LDPE, mLLDPE, EVA, EBA
                    with a tensile strength of 25 MPa offer excellent light
                    transmission, superior heat preservation, and strong tensile
                    strength. They provide economical rain, wind & sun
                    protection to plants, with a lifespan of 5-7 years, ensuring
                    cost-effectiveness without compromising on quality.
                  </motion.p>
                </div>
              </motion.div>
            </div>

            {/* Right Column */}
            <div className="col-md-4">
              <motion.div
                className="card border-0 h-100"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={slideRightT0Left}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <motion.img
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={imageZoom}
                  transition={{ duration: 0.6 }}
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752147630/nvph_knv1je.webp"
                  alt="Grrenhouse Benefits"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "300px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Outside Shading System
                  </h5>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  >
                    Engineered to provide optimal cooling and shading during the
                    summer, this system diffuses sunlight within the greenhouse,
                    effectively shielding crops from harmful sun glare and
                    ensuring consistent growth conditions. Shading systems are
                    utilized widely when you want to grow crops which are
                    locally climatically affected.
                  </motion.p>
                </div>
              </motion.div>
            </div>
          </div>
          <div className="text-center py-5 px-3">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase mt-7"
            >
              Product Parameters
            </motion.h1>

            <hr></hr>
          </div>
          <div
            className=" py-5"
            style={{
              background:
                "color-mix(in srgb,rgb(255, 208, 143) 10%, transparent)",
              color: "black",
              border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
              padding: "1rem",
              borderRadius: "0.25rem",
            }}
          >
            <div className="row">
              <div className="col-12">
                <h3 className="text-success fw-bold mb-4">
                  Technical Specifications
                </h3>
                <div className="table-responsive">
                  <table className="table table-bordered align-middle">
                    <tbody>
                      <tr>
                        <th scope="row">Wind Load</th>
                        <td>0.5 KN/m²</td>
                      </tr>
                      <tr>
                        <th scope="row">Snow Load</th>
                        <td>0.35 KN/m²</td>
                      </tr>
                      <tr>
                        <th scope="row">Maximum Drainage Capacity</th>
                        <td>140 mm/h</td>
                      </tr>
                      <tr>
                        <th scope="row">Span Width</th>
                        <td>4m, 8m, 9.6m, 10.8m, 12.8m or customized</td>
                      </tr>
                      <tr>
                        <th scope="row">Column Spacing</th>
                        <td>4.0m, 8.0m or customized</td>
                      </tr>
                      <tr>
                        <th scope="row">Shoulder Height</th>
                        <td>3.0m – 6.0m or customized</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="col-12 mt-5">
                <p
                  style={{
                    fontSize: "1.05rem",
                    lineHeight: "1.8",
                    color: "#444",
                  }}
                >
                  Plastic film Polytunnel is a simple type of protected
                  cultivation tunnelled greenhouse, which uses transparent
                  plastic films made of polymer materials such as polyethene and
                  polypropylene and connects each arch greenhouse into a whole
                  through the method of connecting wires and buildings. The
                  multi-span polytunnel or greenhouse connects the original
                  independent greenhouse with the original independent single
                  room model greenhouse through reasonable design, increasing
                  the insulation area of the greenhouse and improving its
                  performance
                </p>
              </div>
            </div>
          </div>

          <div className="row g-5 align-items-stretch mt-2">
            {/* Left Column */}
            <div className="col-md-4">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Space Efficiency
                  </h5>
                  <p style={{ fontSize: "18px" }}>
                    Vertical farming makes the most of available space, allowing
                    for more plants to be grown in a given area, making it ideal
                    for urban or indoor farming setups.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div
                className="border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Water Conservation
                  </h5>
                  <p style={{ fontSize: "18px" }}>
                    The closed-loop system recirculates water, significantly
                    reducing water usage compared to traditional soil farming.
                    This makes vertical hydroponics a sustainable option in
                    areas with limited water resources.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-md-4">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Increased Crop Yield
                  </h5>
                  <p style={{ fontSize: "18px" }}>
                    Growing plants in vertical layers maximizes yield per square
                    foot. Vertical hydroponics can produce several times more
                    crops compared to horizontal farming in the same space.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div
                className="border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <h3 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Year-Round Growing
                  </h3>
                  <p style={{ fontSize: "18px" }}>
                    Indoor vertical hydroponics allows for year-round crop
                    production, independent of outdoor weather conditions,
                    resulting in consistent yields and fresh produce throughout
                    the year.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div
                className="border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <h3 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Reduced Pesticide Use
                  </h3>
                  <p style={{ fontSize: "18px" }}>
                    Since the system is enclosed and controlled, there is less
                    exposure to pests, reducing the need for pesticides or
                    herbicides.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div
                className="border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <h3 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Faster Growth
                  </h3>
                  <p style={{ fontSize: "18px" }}>
                    Plants grow faster in hydroponic systems due to the direct
                    delivery of nutrients to the roots, optimal growing
                    conditions, and controlled environments.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center py-5 px-3 mt-7">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase"
            >
              Optional Intelligent Polytunnel Add-ons
            </motion.h1>

            <hr></hr>
          </div>
          <div>
            <div
              className="container  py-5"
              style={{
                background:
                  "color-mix(in srgb,rgb(204, 255, 204) 15%, transparent)",
                color: "#000",
                border: "1px solid #c0e6b6",
                borderRadius: "8px",
                padding: "1rem",
              }}
            >
              <h3 className="text-success fw-bold mb-4">
                Optional Intelligent Polytunnel Add-ons
              </h3>

              <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                  <thead className="table-success">
                    <tr>
                      <th style={{ width: "25%" }}>Add-on</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Steel Structure</th>
                      <td>Hot-galvanized steel pipe</td>
                    </tr>
                    <tr>
                      <th scope="row">Greenhouse Glass</th>
                      <td>Different models can be selected</td>
                    </tr>
                    <tr>
                      <th scope="row">Sun-shading Net</th>
                      <td>
                        Summer shade, block rain, moisture, cooling,
                        winter/spring heat preservation
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Cooling System</th>
                      <td>
                        The fan forms negative pressure and the water curtain
                        cools down
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Heating System</th>
                      <td>
                        Thermal insulation series, air heater, boiler and pipe
                        heating, air circulating fan
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Ventilation System</th>
                      <td>Side windows and cooling fans</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        Water & Fertilizer Integrated Irrigation System
                      </th>
                      <td>
                        Sprinkler irrigation series, drip irrigation series,
                        intelligent mobile sprinkler irrigation
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Automatic Control System</th>
                      <td>
                        Automatic control technology that can independently
                        drive intelligent machines to achieve control objectives
                        without human intervention
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Fill-in Light</th>
                      <td>
                        Easy assemble auto light deprivation blackout greenhouse
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Seedling Bed</th>
                      <td>Movable seeding bed</td>
                    </tr>
                    <tr>
                      <th scope="row">Hydroponics</th>
                      <td>
                        It is reusable, requires no nutrient additions, and is
                        both convenient and inexpensive.
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">External & Internal Shading System</th>
                      <td>The gear rack drives the shading system</td>
                    </tr>
                    <tr>
                      <th scope="row">Photovoltaic System</th>
                      <td>For solar power generation</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="text-center py-5 px-3 mt-7">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase"
            >
              Structure Comparision
            </motion.h1>

            <hr></hr>
          </div>
          <div>
            <div
              className="container  py-5"
              style={{
                background:
                  "color-mix(in srgb,rgb(204, 255, 204) 15%, transparent)",
                color: "#000",
                border: "1px solid #c0e6b6",
                borderRadius: "8px",
                padding: "1rem",
              }}
            >
              <h3 className="text-success fw-bold mb-4">
                Structure Comparision
              </h3>

              <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                  <thead className="table-success">
                    <tr>
                      <th style={{ width: "25%" }}>Features</th>
                      <th>Kryzen Structure</th>
                      <th>Others Structure</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Height of Structure</th>
                      <td>6.8M to 7.2M from Ground Level</td>
                      <td>6.2M to 6.5M from Ground Level</td>
                    </tr>
                    <tr>
                      <th scope="row">Side Ventilation</th>
                      <td>4 meters</td>
                      <td>2.5 meteres</td>
                    </tr>
                    <tr>
                      <th scope="row">Top Vent</th>
                      <td>1.2 to 1.4 meters</td>
                      <td>2.5 meteres</td>
                    </tr>
                    <tr>
                      <th scope="row">Pipe Quality and Galvanization</th>
                      <td>375 GSM to 400 GSM</td>
                      <td>150 GSM to 250 GSM</td>
                    </tr>
                    <tr>
                      <th scope="row">Nut Bolts and Connectors</th>
                      <td>
                        22 Micron Zinc Ferrous Coated<br></br>
                        Main Connectors are 5mm Coated (Zinc Coating)
                      </td>
                      <td>
                        No Coating / 2mm Coating<br></br>
                        Resulting in rusting in 6 months
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Foundation</th>
                      <td>
                        76mm Diameter<br></br>2mm Thickness<br></br>
                        Crimped Foundation gives more strength
                      </td>
                      <td>
                        63mm Diameter<br></br>
                        1.6mm Thickness<br></br>Point Load Foundation is less
                        stable
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterwithoutLogin></FooterwithoutLogin>
    </>
  );
}

export default AFrame;
